export class Thread {
  constructor(
    public id: string,
    public workspaceId: string,
    public title: string,
    public createdAt: Date,
    public updatedAt: Date,
  ) {}

  /**
   * スレッドのタイトルを表示用に短縮する
   */
  get displayTitle(): string {
    const maxLength = 30;
    return this.title.length > maxLength
      ? `${this.title.substring(0, maxLength)}...`
      : this.title;
  }

  /**
   * 相対的な更新時間を取得
   */
  get relativeUpdatedAt(): string {
    const now = new Date();
    const diffInMinutes = Math.floor((now.getTime() - this.updatedAt.getTime()) / (1000 * 60));

    if (diffInMinutes < 1) return "Just now";
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h ago`;

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) return `${diffInDays}d ago`;

    return this.updatedAt.toLocaleDateString();
  }
}
